import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Disclosure,
  DisclosureButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../Context/MyContext";
import galoLogo from "../Assets/Images/galo_solar_logo.png";
import { getCookie } from "../Utils/cookies";
import { useEffect } from "react";

export default function Menubar({isOpen, setIsOpen}) {
  const navigate = useNavigate();
  const { logoutAPI } = useAuth();
  const empData = getCookie("empData") ? JSON.parse(getCookie("empData")) : {};
  const [error, setError] = useState(null);
  useEffect(() => {
    if (error !== null) {
      alert(error);
    }
  }, [error]);

  return (
    <Disclosure as="nav" className="bg-white border border-collapse">
      <div className=" max-w-screen px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            {/* Mobile menu button*/}
            <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="absolute -inset-0.5" />
              <span className="sr-only">Open main menu</span>
              <Bars3Icon
                aria-hidden="true"
                className="block size-6 group-data-[open]:hidden"
              />
              <Bars3Icon
                aria-hidden="true"
                className="hidden size-6 group-data-[open]:block"
              />
            </DisclosureButton>
          </div>
          <div className="flex flex-1 gap-2 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-r from-yellow-400 to-amber-500 flex items-center justify-center font-bold text-black shadow">
                {empData.name ? empData.name.charAt(0) : "U"}
              </div>

              <div>
                <h2 className="font-semibold text-gray-800">{empData.role} Panel</h2>
                <p className="text-xs text-gray-500">Complaint Management System</p>
              </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <Menu as="div" className="relative ml-3 z-21">
              <div className="flex flex-row">
                <MenuButton className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <img alt="" src={galoLogo} className="size-8 rounded-full" />
                </MenuButton>
                <span className="pl-3 pt-1 pr-3 text-dark">
                  {empData?.name}
                </span>
              </div>
              <MenuItems
                transition
                className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                style={{zIndex:21}}
              >
                  <MenuItem>
                    {({ focus }) => (
                      <button
                        onClick={() => navigate("/change-password")}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          focus ? "bg-gray-100 outline-none" : "text-gray-700"
                        }`}
                      >
                        Change Password
                      </button>
                    )}
                  </MenuItem>

                  <MenuItem>
                    {({ focus }) => (
                      <button
                        onClick={() => logoutAPI(setError)}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          focus ? "bg-gray-100 outline-none" : "text-gray-700"
                        }`}
                      >
                        Sign out
                      </button>
                    )}
                  </MenuItem>
              </MenuItems>
            </Menu>
          </div>
        </div>
      </div>
    </Disclosure>
  );
}
